import { Modal } from 'react-bootstrap';
import React from "react";
import { useState, useEffect } from "react";
import { PostControlMC } from '../../../../api';

const ROUTE_URL = "/conf_lsn";
// const initialData = { name: "", address: "" };
let result = { modalResult: 'mrCancel' };

function ModalMfS({ params, handleClose }) {
    const token = localStorage.getItem('token')

    const [show, setShow] = useState(true);
    const [showParrot, setShowParrot] = useState(false)
    const [inputParrot, setInputParrot] = useState(0)
    const [loaded, setLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState({});

    const handleCloseQuery = (event) => {
        if (loading) return;
        result.modalResult = "mrCancel";
        setShow(false);
    }

    const handleCloseParrot = (event) => {
        setShowParrot(false);
        setInputParrot(0);
    }

    const handleAcceptParrot = (id) => {
        setLoading(true);
        let forSend = { boost_signal: 1, signal_value: inputParrot }
        PostControlMC(token, id, forSend).then((e) => {
            setLoading(false);
            setShowParrot(false);
            setInputParrot(0);
        })
    }

    const handleExited = () => {
        setLoaded(false);
        setLoading(false);
        handleClose(result);
    }

    const clickLoading = () => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }

    const clickReboot = (id) => {
        setLoading(true);
        let forSend = { reboot: 1 }
        PostControlMC(token, id, forSend).then((e) => {
            setLoading(false);
        })
    }


    const clickReset = (id) => {
        setLoading(true);
        let forSend = { reset: 1 }
        PostControlMC(token, id, forSend).then((e) => {
            setLoading(false);
        })
    }

    const clickDisableTransmitter = (id) => {
        setLoading(true);
        let forSend = { disable_transmitter: 1 }
        PostControlMC(token, id, forSend).then((e) => {
            setLoading(false);
        })
    }

    const handleBlur = () => {
        // При потере фокуса устанавливаем 0 если поле пустое
        if (inputParrot === '') {
            setInputParrot(0);
        }
    };

    const handleChange = (e) => {
        const inputValue = e.target.value;
        
        // Разрешаем пустую строку для UX
        if (inputValue === '') {
            setInputParrot('');
          return;
        }
        
        const numValue = parseInt(inputValue, 10);
        
        // Проверяем диапазон
        if (!isNaN(numValue)) {
          if (numValue < 0) {
            setInputParrot(0);
          } else if (numValue > 4095) {
            setInputParrot(4095);
          } else {
            setInputParrot(numValue);
          }
        }
    };
    


    let caption = "Просмотр", mode = "R";

    return (
        <>
        <Modal show={show} className={`${params.className ?? ""}`} onHide={handleCloseQuery}
            // onExited={handleExited} centered backdrop="static" keyboard={!(loading || !loaded)}>
            onExited={handleExited} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title className="h6">{caption}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="pb1-1">
                {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                
                <fieldset className="mfuncbutton-fieldset">
                    {loading ? (<div className="spinner-border spinner-border-sm text-primary mfuncbutton-spinner"></div>) : <div className="cont-mfuncbuttons">
                        {
                            <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickReboot(params.id) } >Перезапуск аппаратных средств</button></div>
                        }
                        {
                            <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickReset(params.id)} >Сброс параметров по умолчанию</button></div>
                        }
                        {
                            <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => clickDisableTransmitter(params.id)} >Обесточить радиопередатчик</button></div>
                        }
                        {
                            <div className='cont-mfuncbutton'><button type="button" className="btn btn-primary btn-sm btn-our mfuncbutton" onClick={() => setShowParrot(true)} >Усилить радиосигнал</button></div>
                        }
                    </div>
                    }
                </fieldset>
                {errors._message_ && <div className="form-error mt-2">{errors._message_}</div>}
            </Modal.Body>
            <Modal.Footer>
                {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                <fieldset>
                    <div>
                        <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={handleCloseQuery}>Закрыть</button>
                    </div>
                </fieldset>
            </Modal.Footer>
        </Modal >
             <Modal show={showParrot} className={`${params.className ?? "modal-parrot"}`} onHide={handleCloseParrot}
             // onExited={handleExited} centered backdrop="static" keyboard={!(loading || !loaded)}>
             onExited={() => setShowParrot(false)} centered backdrop="static">
             <Modal.Header closeButton>
                 <Modal.Title className="h6">Усилить радиосигнал</Modal.Title>
             </Modal.Header>
             <Modal.Body className="pb1-1">
                 {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                 <fieldset className="mfuncbutton-fieldset">
               <input onBlur={handleBlur} min="0" max="4095" value={inputParrot} type="number" className='input-parrot' onChange={handleChange}></input>
                 </fieldset>
             </Modal.Body>
             <Modal.Footer>
                 {/* <fieldset disabled={loading || !loaded || !params.show}> */}
                 <fieldset>
                     <div className='cont-btn'>
                         <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={handleCloseParrot}>Закрыть</button>
                         <button type="button" className="btn btn-secondary btn-sm btn-our ms-2" onClick={() => handleAcceptParrot(params.id)}>Применить</button>
                     </div>
                     
                 </fieldset>
             </Modal.Footer>
         </Modal >
         </>

    );
}

const reducerModalWindow = (state, action) => {
    switch (action.type) {
        case 'def':
            return { ...state, show: true, id: action.id, isNew: false };
        case 'destroy':
            return { ...state, show: false, id: null };
        default:
            return state;
    }
}

export { ModalMfS, reducerModalWindow };
